import { MachineObjectType } from "../../../contexts/MachineContext";

interface FieldsAndValuesInterface{
  label:string;
  type:string;
  value:keyof MachineObjectType;
  placeholder?:string
}

export const fieldsAndValues:FieldsAndValuesInterface[] = [
  {
    label: 'Identificação',
    type: 'text',
    value: 'identification'
  },
  {
    label: 'Modelo',
    type: 'text',
    value: 'model'
  },
  {
    label: 'Custo por hora',
    type: 'cash',
    value: 'costPerHour',
    placeholder: 'R$ 00,00'
  },
  {
    label: 'Unidade de medida',
    type: 'select',
    value: 'unitOfMeasure'
  },
  {
    label: 'Capacidade miníma',
    type: 'text',
    value: 'productionCapacityMin'
  },
  {
    label: 'Capadidade máxima',
    type: 'text',
    value: 'productionCapacityMax'
  },
  {
    label: 'Peso da máquina (kg)',
    type: 'text',
    value: 'weight'
  },
  {
    label: 'Altura (m)',
    type: 'text',
    value: 'height'
  },
  {
    label: 'Largura (m)',
    type: 'text',
    value: 'width'
  },
  {
    label: 'Comprimento (m)',
    type: 'text',
    value: 'length'
  },
  {
    label: 'Última manutenção',
    type: 'date',
    value: 'lastMaintenance'
  },
  {
    label: 'Próxima manutenção',
    type: 'date',
    value: 'nextMaintenance'
  },
]